import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { buildAlertDeleteButtonId } from '@Pages/Alerts/AlertsUtils';

export default function ResultEditButtons({ id, handleViewDeleteModal, openEditAlert }) {
  const handleEdit = useCallback(() => openEditAlert(id), [openEditAlert, id]);
  const handleDelete = useCallback(() => handleViewDeleteModal(true, id), [handleViewDeleteModal, id]);

  return (
    <section className="result-edit-buttons els-btn-group">
      <ButtonWithIcon
        data-e2e="alert-edit-button"
        type="link"
        sprite="Edit"
        iconRight
        className={`alerts--second-line results-from--edit-button e2e-${id}-edit`}
        onClick={handleEdit}>
        Edit
      </ButtonWithIcon>

      <ButtonWithIcon
        data-e2e="alert-delete-button"
        id={buildAlertDeleteButtonId(id)}
        type="link"
        sprite="Trash"
        iconRight
        className={`alerts--second-line e2e-${id}-delete`}
        onClick={handleDelete}>
        Delete
      </ButtonWithIcon>
    </section>
  );
}

ResultEditButtons.propTypes = {
  id: PropTypes.string.isRequired,
  handleViewDeleteModal: PropTypes.func.isRequired,
  openEditAlert: PropTypes.func.isRequired,
};
